var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"partner-order"}},[_c('div',{staticClass:"po-top-container"},[_c('div',{staticClass:"po-header-container"},[_c('div',{staticClass:"header"},[_vm._v(" Partner Orders ")]),_c('SelectedPartner')],1)]),_c('div',{staticClass:"po-body-container"},[_c('div',{staticClass:"po-content-container"},[_c('PartnerOrderTable')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }